/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerGuaranteeDto } from './BorrowerGuaranteeDto';
import {
    BorrowerGuaranteeDtoFromJSON,
    BorrowerGuaranteeDtoFromJSONTyped,
    BorrowerGuaranteeDtoToJSON,
    BorrowerGuaranteeDtoToJSONTyped,
} from './BorrowerGuaranteeDto';
import type { BorrowerContractualizationPricingDto } from './BorrowerContractualizationPricingDto';
import {
    BorrowerContractualizationPricingDtoFromJSON,
    BorrowerContractualizationPricingDtoFromJSONTyped,
    BorrowerContractualizationPricingDtoToJSON,
    BorrowerContractualizationPricingDtoToJSONTyped,
} from './BorrowerContractualizationPricingDto';

/**
 * 
 * @export
 * @interface BorrowerPricingWithGuaranteeDto
 */
export interface BorrowerPricingWithGuaranteeDto {
    /**
     * 
     * @type {BorrowerContractualizationPricingDto}
     * @memberof BorrowerPricingWithGuaranteeDto
     */
    pricing: BorrowerContractualizationPricingDto;
    /**
     * 
     * @type {Array<BorrowerGuaranteeDto>}
     * @memberof BorrowerPricingWithGuaranteeDto
     */
    guarantees: Array<BorrowerGuaranteeDto>;
}

/**
 * Check if a given object implements the BorrowerPricingWithGuaranteeDto interface.
 */
export function instanceOfBorrowerPricingWithGuaranteeDto(value: object): value is BorrowerPricingWithGuaranteeDto {
    if (!('pricing' in value) || value['pricing'] === undefined) return false;
    if (!('guarantees' in value) || value['guarantees'] === undefined) return false;
    return true;
}

export function BorrowerPricingWithGuaranteeDtoFromJSON(json: any): BorrowerPricingWithGuaranteeDto {
    return BorrowerPricingWithGuaranteeDtoFromJSONTyped(json, false);
}

export function BorrowerPricingWithGuaranteeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerPricingWithGuaranteeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pricing': BorrowerContractualizationPricingDtoFromJSON(json['pricing']),
        'guarantees': ((json['guarantees'] as Array<any>).map(BorrowerGuaranteeDtoFromJSON)),
    };
}

export function BorrowerPricingWithGuaranteeDtoToJSON(json: any): BorrowerPricingWithGuaranteeDto {
    return BorrowerPricingWithGuaranteeDtoToJSONTyped(json, false);
}

export function BorrowerPricingWithGuaranteeDtoToJSONTyped(value?: BorrowerPricingWithGuaranteeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pricing': BorrowerContractualizationPricingDtoToJSON(value['pricing']),
        'guarantees': ((value['guarantees'] as Array<any>).map(BorrowerGuaranteeDtoToJSON)),
    };
}

